import router from '@/router'
import { ApiError } from '@/helper/api-error'
import { RequestError } from '@/helper/request-error'
import { ValidatorError } from '@/helper/validator-error'
import authenticationService from '@/services/authentication.service'
import store from '@/store'

/* tslint:disable:cyclomatic-complexity */
export default function rethrowApiError(error: any) {
  console.error(error)
  let newError
  if (error.response && error.response.status === 401) {
    authenticationService.saveCurrentLocationAsPrev({
      name: router.currentRoute.name,
    })
    authenticationService.authenticateUser()
  } else if (error.response === undefined || [500, 404].includes(error.response.status)) {
    store.dispatch(
      'setGlobalError',
      error.response && error.response.body && error.response.body.message ?
        error.response.body.message : `Une erreur indéterminée s'est produite.
        Veuillez recharger la page et contacter le support si le problème persiste.`,
    )
  }

  if (error.response && error.response.body) {
    if (error.response.body.errors) {
      newError = new ValidatorError(
        error.response.body.message || error.message,
        error.status,
        error.response.body.code,
        error.response.body.errors,
      )
    } else {
      newError = new ApiError(
        error.response.body.message || error.message,
        error.status,
        error.response.body.code,
      )
    }
  } else {
    newError = new RequestError(error.message)
  }
  throw newError
}
